import {useMemo} from 'react';
import {ArrowIcon} from '../svg/ArrowIcon';
import {CloseLineIcon} from '../svg/CloseLineIcon';
import {formatHeaderTitle} from '../utils/utils';
import {Button} from './Button';
import {Typography} from './Typography';

export const PanelHeaderRow = ({
  title,
  onClose,
  qaId,
  backArrow = false,
  titleVariant = 'list2',
  showTitle,
}) => {
  const formattedTitle = useMemo(() => formatHeaderTitle(title), [title]);

  if (backArrow) {
    return (
      <div className="panel-header-row">
        <Button
          variant="transparent"
          onClick={() => onClose()}
          data-qa-id={`${qaId}_back_button`}
          type="button"
          ariaLabel="Back"
        >
          <ArrowIcon direction="left" ratio={0.75} />
        </Button>
        <Typography variant={titleVariant} size="large">
          {formattedTitle}
        </Typography>
      </div>
    );
  }

  if (!title && !showTitle) {
    return (
      <Button
        className="panel-header-row__close-btn-absolute"
        variant="transparent"
        onClick={() => onClose()}
        data-qa-id={`${qaId}_close_button`}
        type="button"
        ariaLabel="Close"
      >
        <CloseLineIcon ratio={0.75} />
      </Button>
    );
  }

  return (
    <div className="panel-header-row">
      <Typography variant={titleVariant} size="large">
        {formattedTitle}
      </Typography>
      <Button
        variant="transparent"
        onClick={() => onClose()}
        data-qa-id={`${qaId}_close_button`}
        type="button"
        ariaLabel="Close"
      >
        <CloseLineIcon ratio={0.75} />
      </Button>
    </div>
  );
};
